<script>
export default {
  data () {
    return {
      isTaskOutcomeDialogVisible: false,
      selectedTaskOutcomeTask: {},
      selectedTaskOutcomeUserId: ''
    }
  },
  methods: {
    clearSelectedOutcomeTaskAndUserId () {
      this.selectedTaskOutcomeTask = {}
      this.selectedTaskOutcomeUserId = ''
    },
    showTaskOutcomeDialog ({ task = {}, userId = '' }) {
      this.selectedTaskOutcomeTask = task
      this.selectedTaskOutcomeUserId = userId
      this.isTaskOutcomeDialogVisible = true
    }
  }
}
</script>
